export const DIALOG_PORTAL_KEY = 'welcome-dialog';
